import revive_payload_client_4sVQNw7RlN from "/working_dir/site/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_KgADcZ0jPj from "/working_dir/site/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "/working_dir/site/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import payload_client_yVLowv6hDl from "/working_dir/site/node_modules/nuxt/dist/app/plugins/payload.client.js";
import navigation_repaint_client_bs2bWDGRIE from "/working_dir/site/node_modules/nuxt/dist/app/plugins/navigation-repaint.client.js";
import check_outdated_build_client_8vK7RkfGxZ from "/working_dir/site/node_modules/nuxt/dist/app/plugins/check-outdated-build.client.js";
import chunk_reload_client_UciE0i6zes from "/working_dir/site/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import plugin_vue3_YdLad5Mpq3 from "/working_dir/site/node_modules/@pinia/nuxt/dist/runtime/plugin.vue3.js";
import components_plugin_KR1HBZs4kY from "/working_dir/site/.nuxt/components.plugin.mjs";
import prefetch_client_5tzzN0oIVL from "/working_dir/site/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import switch_locale_path_ssr_5csfIgkrBP from "/working_dir/site/node_modules/@nuxtjs/i18n/dist/runtime/plugins/switch-locale-path-ssr.js";
import i18n_sq1MuCrqbC from "/working_dir/site/node_modules/@nuxtjs/i18n/dist/runtime/plugins/i18n.js";
import fontawesome_7xXmPH2btU from "/working_dir/site/node_modules/@vesp/nuxt-fontawesome/dist/runtime/plugins/fontawesome.js";
import bootstrap_client_Uyd73t1ylZ from "/working_dir/site/plugins/bootstrap.client.ts";
import dompurify_qvTkTTURiH from "/working_dir/site/plugins/dompurify.ts";
import google_analytics_client_KruZkwwzId from "/working_dir/site/plugins/google-analytics.client.ts";
import google_tag_manager_client_EITxCwySk0 from "/working_dir/site/plugins/google-tag-manager.client.ts";
import scroll_to_target_l3SP7svTGD from "/working_dir/site/plugins/scroll-to-target.ts";
export default [
  revive_payload_client_4sVQNw7RlN,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  payload_client_yVLowv6hDl,
  navigation_repaint_client_bs2bWDGRIE,
  check_outdated_build_client_8vK7RkfGxZ,
  chunk_reload_client_UciE0i6zes,
  plugin_vue3_YdLad5Mpq3,
  components_plugin_KR1HBZs4kY,
  prefetch_client_5tzzN0oIVL,
  switch_locale_path_ssr_5csfIgkrBP,
  i18n_sq1MuCrqbC,
  fontawesome_7xXmPH2btU,
  bootstrap_client_Uyd73t1ylZ,
  dompurify_qvTkTTURiH,
  google_analytics_client_KruZkwwzId,
  google_tag_manager_client_EITxCwySk0,
  scroll_to_target_l3SP7svTGD
]